var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoBannerBlueWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3986 3.3986C5.34317 1.45406 8.0317 0.25 11 0.25C13.9683 0.25 16.6568 1.45406 18.6014 3.3986C20.5459 5.34317 21.75 8.0317 21.75 11C21.75 13.9683 20.5459 16.6568 18.6014 18.6014C16.6568 20.5459 13.9683 21.75 11 21.75C8.0317 21.75 5.34317 20.5459 3.3986 18.6014C1.45406 16.6568 0.25 13.9683 0.25 11C0.25 8.0317 1.45407 5.34316 3.3986 3.3986ZM11 1.75C8.4455 1.75 6.13403 2.78452 4.45926 4.45926C2.78451 6.13404 1.75 8.4455 1.75 11C1.75 13.5545 2.78452 15.866 4.45926 17.5407C6.13403 19.2155 8.4455 20.25 11 20.25C13.5545 20.25 15.866 19.2155 17.5407 17.5407C19.2155 15.866 20.25 13.5545 20.25 11C20.25 8.4455 19.2155 6.13403 17.5407 4.45926C15.866 2.78452 13.5545 1.75 11 1.75Z",
    fill: "#0E8ACD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.5C11.6903 4.5 12.25 5.05965 12.25 5.75C12.25 6.44035 11.6903 7 11 7C10.3097 7 9.75 6.44035 9.75 5.75C9.75 5.05965 10.3097 4.5 11 4.5Z",
    fill: "#0E8ACD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 9C9.5 8.58579 9.83579 8.25 10.25 8.25H11.25C11.6642 8.25 12 8.58579 12 9V16C12 16.4142 11.6642 16.75 11.25 16.75C10.8358 16.75 10.5 16.4142 10.5 16V9.75H10.25C9.83579 9.75 9.5 9.41421 9.5 9Z",
    fill: "#0E8ACD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 16C8.75 15.5858 9.08579 15.25 9.5 15.25H13C13.4142 15.25 13.75 15.5858 13.75 16C13.75 16.4142 13.4142 16.75 13 16.75H9.5C9.08579 16.75 8.75 16.4142 8.75 16Z",
    fill: "#0E8ACD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBannerBlueWarning);
export default __webpack_public_path__ + "static/media/info-banner-blue-warning.ba294144.svg";
export { ForwardRef as ReactComponent };